<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swal from "sweetalert2";
import {NeshanMapLeaflet} from "vuejs-neshan-map-leaflet";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "DetailsOrders",
  components: {NavbarPage, NeshanMapLeaflet, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let order_id = useRoute().params.ord_id
    let data_ord = ref(null)

    let loading = ref(false)

    let page = ref('ric')

    let lat = ref(null)
    let long = ref(null)


    let map = ref(false)
    let options_map = ref({
      key: 'web.1c66e9d7d7704759bb20b5681a167d01',
      maptype: 'dreamy',
      poi: true,
      traffic: false,
      zoom: 17,
    })

    function load_data() {

      loading.value = true
      FreeWorld.Heisenberg({order_id: order_id}, 'detail_order').then((result) => {

        loading.value = false
        let res = result.data
        data_ord.value = res
        options_map.value.center = [res.lat, res.long]
        lat.value = res.lat
        long.value = res.long
        map.value = true

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_data()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_data()
            }
          })
        }
      })

    }

    load_data()

    return {

      loading,
      data_ord,
      page,
      map,
      options_map,
      lat,
      long,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" :class="loading ? 'activeClass' : '' " id="main" class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          جزییات سفارش
        </p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>

      </div>
    </div>
    <br>
    <br>
    <br>


    <div v-if="data_ord != null && data_ord.sending_info != null"
         class="w-100 d-flex justify-content-between p-body mt-3 mb-6">

      <v-btn @click="page = 'send' " :class="page == 'send' ? 'bg-color':'bg-unavailable' "
             class="w-45 px-2 py-3 h-100 rounded-3 text-white">جزییات ارسال
      </v-btn>
      <v-btn @click="page = 'ric' " :class="page == 'ric' ? 'bg-color':'bg-unavailable' "
             class="w-45 px-2 py-3 h-100 rounded-3 text-white">جزییات گیرنده
      </v-btn>

    </div>

    <div v-if="data_ord != null">
      <div v-if="page == 'ric' ">
        <div v-if="data_ord != null" class="p-body animate__animated animate__fadeIn">

          <div class="bg-white rounded-4 p-3 p-body my-3">

            <div class="d-flex justify-content-between align-items-center py-2 ">

              <p class="m-0 w-60 font-4">{{ data_ord.state }}</p>

              <p class="m-0 font-4 font-bold">
                : استان
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.city }}</p>

              <p class="m-0 font-4 font-bold">
                : شهر
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.code_posty }}</p>

              <p class="m-0 font-4 font-bold">
                : کد پستی
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.phone }}</p>

              <p class="m-0 font-4 font-bold">
                : شماره همراه
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.recipient_name }}</p>

              <p class="m-0 font-4 font-bold">
                : نام گیرنده
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-70 font-4">{{ data_ord.address }}</p>

              <p class="m-0 font-4 font-bold">
                : آدرس
              </p>

            </div>


            <p dir="rtl" class="font-5 mt-7 mb-2">برای اطلاعات بیشتر لوکیشن روی نقشه کلیک کنید</p>
            <a :href="'http://maps.google.com/maps?z=20&t=m&q=loc:'+lat +'+'+long" class="w-100 position-relative">
              <div style="height: 280px" class="pe-none">
                <NeshanMapLeaflet
                    v-if="map"
                    class="w-100 h-100 rounded-4"
                    :options="options_map"
                />
              </div>
            </a>


          </div>

          <div v-if="data_ord.status == 3 || data_ord.status == 4"
               class="w-100 mt-7 d-flex justify-content-center mb-3">
            <a :href="'https://decoban.ir/project_decoran/factor_print?order_id=' + data_ord.id" class="w-50">
              <v-btn class="w-100 bg-color py-3 h-100 rounded-3 text-white">دانلود فاکتور</v-btn>
            </a>
          </div>

        </div>
      </div>

      <div v-if="page == 'send' ">
        <div v-if="data_ord.sending_info != null && data_ord.sending_info.type_send == 'car'"
             class="p-body animate__animated animate__fadeIn">

          <div class="bg-white rounded-4 p-3 p-body mt-3">

            <div class="d-flex justify-content-between align-items-center py-2 ">

              <p class="m-0 w-60 font-4">ارسال توسط فروشنده</p>

              <p class="m-0 font-4 font-bold">
                : طریقه ارسال سفارش
              </p>

            </div>

            <hr>

            <div class="d-flex justify-content-between align-items-center py-2 ">

              <p class="m-0 w-60 font-4">{{ data_ord.sending_info.driver_name }}</p>

              <p class="m-0 font-4 font-bold">
                : نام راننده
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.sending_info.code_melli }}</p>

              <p class="m-0 font-4 font-bold">
                : کد ملی راننده
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.sending_info.phone }}</p>

              <p class="m-0 font-4 font-bold">
                : شماره همراه
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p class="m-0 w-60 font-4">{{ data_ord.sending_info.model_car }}</p>

              <p class="m-0 font-4 font-bold">
                : وسیله نقلیه
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p dir="rtl" class="text-end m-0 w-60 font-4">{{ data_ord.sending_info.pelak }}</p>

              <p class="m-0 font-4 font-bold">
                : پلاک وسیله نقلیه
              </p>

            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center py-2">

              <p v-if="data_ord.sending_info.info != null" class="m-0 w-60 font-4">{{ data_ord.sending_info.info }}</p>
              <p v-else class="m-0 w-60 font-4">توضیحاتی وارد نشده</p>

              <p class="m-0 font-4 font-bold">
                : توضیحات
              </p>

            </div>

          </div>

        </div>

        <div v-else class="p-body animate__animated animate__fadeIn">

          <div class="bg-white rounded-4 p-3 p-body mt-3">

            <div class="d-flex justify-content-between align-items-center py-2 ">

              <p class="m-0 w-60 font-4">ارسال توسط پست</p>

              <p class="m-0 font-4 font-bold">
                : طریقه ارسال سفارش
              </p>

            </div>

            <hr>

            <div class="d-flex justify-content-between align-items-center py-2 ">

              <div class="w-60 overflow-hidden d-flex justify-content-center align-items-center">
                <p class="m-0 w-100 font-4 overflow-hidden" :class="{'txtoverflow': data_ord?.sending_info?.tracking_code?.length > 25}">{{ data_ord.sending_info.tracking_code }}</p>
              </div>

              <p class="m-0 font-4 font-bold">
                : کد رهگیری پستی
              </p>

            </div>

          </div>

        </div>
      </div>
    </div>

  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">جزییات سفارش</div>

    <div dir="ltr" class="rounded-4 bg-white w-75 m-auto p-4">

      <div v-if="data_ord != null && data_ord.sending_info != null"
           class="w-100 d-flex justify-content-between mb-3">

        <v-btn @click="page = 'send' " :class="page == 'send' ? 'bg-color':'bg-unavailable' "
               class="w-45 py-3 h-100 rounded-3 text-white">جزییات ارسال
        </v-btn>
        <v-btn @click="page = 'ric' " :class="page == 'ric' ? 'bg-color':'bg-unavailable' "
               class="w-45 py-3 h-100 rounded-3 text-white">جزییات گیرنده
        </v-btn>

      </div>

      <div v-if="data_ord != null">
        <div v-if="page == 'ric' ">
          <div v-if="data_ord != null" class="animate__animated animate__fadeIn">

            <div class="bg-white rounded-4 p-3 p-body my-3">

              <div class="d-flex justify-content-between align-items-center py-2 ">

                <p class="m-0 w-60 font-4">{{ data_ord.state }}</p>

                <p class="m-0 font-4 font-bold">
                  : استان
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.city }}</p>

                <p class="m-0 font-4 font-bold">
                  : شهر
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.code_posty }}</p>

                <p class="m-0 font-4 font-bold">
                  : کد پستی
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.phone }}</p>

                <p class="m-0 font-4 font-bold">
                  : شماره همراه
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.recipient_name }}</p>

                <p class="m-0 font-4 font-bold">
                  : نام گیرنده
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-70 font-4">{{ data_ord.address }}</p>

                <p class="m-0 font-4 font-bold">
                  : آدرس
                </p>

              </div>


              <p dir="rtl" class="font-5 mt-7 mb-2">برای اطلاعات بیشتر لوکیشن روی نقشه کلیک کنید</p>
              <a :href="'http://maps.google.com/maps?z=20&t=m&q=loc:'+lat +'+'+long" class="w-100 position-relative">
                <div style="height: 280px" class="pe-none">
                  <NeshanMapLeaflet
                      v-if="map"
                      class="w-100 h-100 rounded-4"
                      :options="options_map"
                  />
                </div>
              </a>


            </div>

            <div v-if="data_ord.status == 3 || data_ord.status == 4"
                 class="w-100 mt-7 d-flex justify-content-center mb-3">
              <a :href="'https://decoban.ir/project_decoran/factor_print?order_id=' + data_ord.id" class="w-50">
                <v-btn class="w-100 bg-color py-3 h-100 rounded-3 text-white">دانلود فاکتور</v-btn>
              </a>
            </div>

          </div>
        </div>

        <div v-if="page == 'send' ">
          <div v-if="data_ord.sending_info != null && data_ord.sending_info.type_send == 'car'"
               class="animate__animated animate__fadeIn">

            <div class="bg-white rounded-4 p-3 p-body mt-3">

              <div class="d-flex justify-content-between align-items-center py-2 ">

                <p class="m-0 w-60 font-4">ارسال توسط فروشنده</p>

                <p class="m-0 font-4 font-bold">
                  : طریقه ارسال سفارش
                </p>

              </div>

              <hr>

              <div class="d-flex justify-content-between align-items-center py-2 ">

                <p class="m-0 w-60 font-4">{{ data_ord.sending_info.driver_name }}</p>

                <p class="m-0 font-4 font-bold">
                  : نام راننده
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.sending_info.code_melli }}</p>

                <p class="m-0 font-4 font-bold">
                  : کد ملی راننده
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.sending_info.phone }}</p>

                <p class="m-0 font-4 font-bold">
                  : شماره همراه
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p class="m-0 w-60 font-4">{{ data_ord.sending_info.model_car }}</p>

                <p class="m-0 font-4 font-bold">
                  : وسیله نقلیه
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p dir="rtl" class="text-end m-0 w-60 font-4">{{ data_ord.sending_info.pelak }}</p>

                <p class="m-0 font-4 font-bold">
                  : پلاک وسیله نقلیه
                </p>

              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center py-2">

                <p v-if="data_ord.sending_info.info != null" class="m-0 w-60 font-4">{{
                    data_ord.sending_info.info
                  }}</p>
                <p v-else class="m-0 w-60 font-4">توضیحاتی وارد نشده</p>

                <p class="m-0 font-4 font-bold">
                  : توضیحات
                </p>

              </div>

            </div>

          </div>

          <div v-else class="p-body animate__animated animate__fadeIn">

            <div class="bg-white rounded-4 p-3 p-body mt-3">

              <div class="d-flex justify-content-between align-items-center py-2 ">

                <p class="m-0 w-60 font-4">ارسال توسط پست</p>

                <p class="m-0 font-4 font-bold">
                  : طریقه ارسال سفارش
                </p>

              </div>

              <hr>

              <div class="d-flex justify-content-between align-items-center py-2 ">

                <p class="m-0 w-60 font-4">{{ data_ord.sending_info.tracking_code }}</p>

                <p class="m-0 font-4 font-bold">
                  : کد رهگیری پستی
                </p>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped>


</style>